import React, { useEffect, useState } from 'react';
import './Countdown.css';

/**
 * 限时倒计时组件：从进入页面起倒计时（默认 30 分钟），到 0 显示「活动结束」。
 * 用于制造紧迫感。
 */
const Countdown = ({ minutes = 30 }) => {
  const [left, setLeft] = useState(minutes * 60);

  useEffect(() => {
    const t = setInterval(() => {
      setLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(t);
  }, []);

  if (left <= 0) return null;

  const h = String(Math.floor(left / 3600)).padStart(2, '0');
  const m = String(Math.floor((left % 3600) / 60)).padStart(2, '0');
  const s = String(left % 60).padStart(2, '0');

  return (
    <div className="countdown">
      <span className="countdown-dot" />
      <span className="countdown-text">Ends in</span>
      <span className="countdown-time">{h}:{m}:{s}</span>
    </div>
  );
};

export default Countdown;
